<template>
    <div id="report-customer-satisfaction">
        <div class="overall-content">
            <div class="chart-container">
                <div class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon rating-icon">
                            <md-icon>star</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t("report.ratingOverall") }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.ratingOverallDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <OverallRatingChart title="Customer Rating Timeseries" :filters="filters" />
                    </div>
                </div>

                <div class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon wait-icon">
                            <md-icon>hourglass_empty</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t('report.agentWaitDurationTitle') }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.agentWaitDurationDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <AgentWaitDurationTimeseries :title="$t('report.agentWaitDurationTitle')" :filters="filters" />
                    </div>
                </div>

                <div class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon comments-icon">
                            <md-icon>comment</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t('report.topComments') }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.topCommentsDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <TopComments :title="$t('report.topComments')" :filters="filters" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import log2 from "../../../utils/log2";
import moment from "moment";
import OverallRatingChart from "../overall/OverallRatingChart.vue";
import AgentWaitDurationTimeseries from "./AgentWaitDurationTimeseries.vue";
import TopComments from "./TopComments.vue";

const log = log2("CustomerSatisfaction");
export default {
    name: "CustomerSatisfaction",
    components: {
        TopComments,
        AgentWaitDurationTimeseries,
        OverallRatingChart,
    },
    props: {
        loading: {
            type: Boolean,
            default: true,
        },
        filters: {
            type: Object,
            default: () => ({
                users: [],
                channels: [],
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
};
</script>
<style lang="scss" scoped>
#report-customer-satisfaction {
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;

    .overall-content {
        padding: 16px;
        display: flex;
        flex-direction: column;
        background: var(--color-bg-neutral, #f5f5f5);
        width: 100%;
        min-height: 100vh;

        .chart-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 24px;

            .report-card {
                background: #fff;
                border-radius: 12px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
                overflow: hidden;
                transition: box-shadow 0.2s ease;

                &:hover {
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);
                }

                .report-card-header {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    padding: 20px 24px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.06);

                    .report-card-icon {
                        width: 44px;
                        height: 44px;
                        border-radius: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;

                        i {
                            font-size: 22px !important;
                            color: #fff;
                        }

                        &.rating-icon {
                            background: linear-gradient(135deg, #f59e0b, #d97706);
                        }

                        &.wait-icon {
                            background: linear-gradient(135deg, #f97316, #ea580c);
                        }

                        &.comments-icon {
                            background: linear-gradient(135deg, #8b5cf6, #7c3aed);
                        }
                    }

                    .report-card-title {
                        h2 {
                            font-size: 18px;
                            font-weight: 600;
                            margin: 0;
                            color: #1a1a1a;
                        }

                        .report-card-subtitle {
                            font-size: 13px;
                            color: #6b7280;
                            margin: 2px 0 0 0;
                        }
                    }
                }

                .report-card-body {
                    padding: 20px 24px;
                }
            }
        }
    }
}
</style>